<template>
  <div v-view.once="viewHandler" class="article-product-short-details-container PDP">
    <a :href="productUrl">
      <img :src="image" :alt="title" @click="productclick()" />
    </a>
    <div class="title-container" @click="urlRedirection">
      <div class="categoryname">{{ categoryName }}</div>
      <div class="productname">{{ productName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-short-details',
  props: {
    image: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productUrl: {
      type: String,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
    navTag: {
      type: Boolean,
      default: false,
    },
    productSku: {
      type: String,
      required: true,
    },
    productBrand: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
    listTittle: {
      type: String,
      required: true,
    },
    productPosition: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      datalayers: {
        event: 'nievent',
        eventCategory: 'Ecommerce',
        eventAction: 'Product Impressions',
        eventLabel: 'product selector page',
        event_name: 'view_item_list',
        ecommerce: {
          impressions: 'impressions',
          product: [],
        },
      },
    };
  },
  mounted() {
    let scrollTimer = null;
    window.addEventListener('scroll', () => {
      window.clearInterval(scrollTimer);
      scrollTimer = setTimeout(() => {
        this.pushDatalayerEvent();
      }, 500);
    });
  },
  methods: {
    urlRedirection() {
      if (this.navTag) {
        window.location.href = this.productUrl;
      }
    },
    productclick() {
      dataLayer.push({
        event: 'productClick',
        eventCategory: 'Ecommerce',
        eventAction: 'Product Click',
        eventLabel: `${this.categoryName}::${this.productSku}`,
        event_name: 'select_item',
        product_info: `${this.productName}::${this.productSku}`,
        ecommerce: {
          click: {
            products: {
              name: this.categoryName,
              id: this.productSku,
              brand: this.productBrand,
              category: this.productCategory,
              dimension48: this.productSku,
            },
            actionField: {
              list: 'product selector page',
            },
          },
        },
      });
    },
    pushDatalayerEvent() {
      dataLayer.push(this.datalayers);
    },
    viewHandler(e) {
      console.log(e);
      if (e.type === 'enter') {
        this.datalayers.ecommerce.product.push({
          name: this.productName,
          id: this.productSku,
          brand: this.productBrand,
          category: this.productCategory,
          list: this.listTittle,
          position: this.productPosition,
          dimension48: this.productSku,
        });
      }
    },
  },
};
</script>
